var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "114.791%",
    y2: ".822%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D0D3D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 108.009,
    cy: 108,
    r: 108
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "94.781%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.246
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.01)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    transform: "matrix(1 0 0 -1 0 216)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M102.08 189.295h45.613v-49.982c0-2.533-2.028-4.586-4.53-4.586H102.08v54.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M121.507 143.254h25.341v-1.706h-25.34zM121.507 145.811h25.341v-1.705h-25.34zM121.507 150.074h25.341v-1.705h-25.34zM121.507 152.632h25.341v-1.705h-25.34zM121.507 156.043h25.341v-1.705h-25.34zM121.507 160.306h25.341V158.6h-25.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M149.382 187.59h-38.01V78.542c0-3.345 2.7-6.056 6.03-6.056h31.98V187.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M149.382 187.59h-16.049V72.486h10.208c3.226 0 5.841 2.66 5.841 5.942V187.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M133.333 89.539h16.049V86.98h-16.049zM133.333 97.212h16.049v-2.558h-16.049zM133.333 104.886h16.049v-2.558h-16.049zM133.333 112.56h16.049V110h-16.049zM133.333 120.233h16.049v-2.558h-16.049zM133.333 127.906h16.049v-2.557h-16.049z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323948",
    d: "M110.363 109.887h21.962v-2.558h-21.962zM110.363 101.887h21.962V99.33h-21.962zM110.363 93.887h21.962V91.33h-21.962zM110.526 117.212h21.962v-2.558h-21.962zM110.526 124.886h21.962v-2.558h-21.962zM110.526 132.56h21.962V130h-21.962zM110.526 140.233h21.962v-2.558h-21.962zM110.526 147.906h21.962v-2.557h-21.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M189.21 169.67h-16.05V86.968h11.09c2.739 0 4.96 2.251 4.96 5.028v77.676z",
    transform: "translate(-149.637 21.33)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363B44",
    d: "M23.524 118.528h16.049v-1.706h-16.05zM23.524 122.79h16.049v-1.705h-16.05zM23.524 127.906h16.049v-1.705h-16.05zM23.524 133.875h16.049v-1.705h-16.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#616166",
    d: "M23.524 138.99h16.049v-1.705h-16.05zM23.524 144.959h16.049v-1.705h-16.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323948",
    d: "M1.562 118.528h21.962v-1.706H1.562zM1.562 122.79h21.962v-1.705H1.562zM1.562 127.906h21.962v-1.705H1.562zM1.562 133.875h21.962v-1.705H1.562zM1.562 138.99h21.962v-1.705H1.562zM1.562 144.959h21.962v-1.705H1.562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M90.254 187.59h-27.03V48.364l27.03-27.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M239.89 166.26h16.05V0h-16.05z",
    transform: "translate(-149.637 21.33)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323948",
    d: "M96.167 126.201h1.69V21.33h-1.69zM100.39 126.201h1.69V21.33h-1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M129.954 188.442h33.788V64.812h-33.788z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M315.068 167.113h15.204V43.483h-15.204zM353.079 171.376h7.602v-68.21h-7.602z",
    transform: "translate(-149.637 21.33)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323948",
    d: "M135.022 103.18h10.137v-1.705h-10.137zM149.382 103.18h10.136v-1.705h-10.136zM135.022 106.591h10.137v-1.705h-10.137zM149.382 106.591h10.136v-1.705h-10.136zM135.022 129.612h10.137v-1.706h-10.137zM149.382 129.612h10.136v-1.706h-10.136zM135.022 134.727h10.137v-1.705h-10.137zM149.382 134.727h10.136v-1.705h-10.136zM135.022 138.99h10.137v-1.705h-10.137zM149.382 138.99h10.136v-1.705h-10.136zM135.022 144.106h10.137v-1.705h-10.137zM149.382 144.106h10.136v-1.705h-10.136zM135.022 147.517h10.137v-1.706h-10.137zM149.382 147.517h10.136v-1.706h-10.136zM135.022 152.632h10.137v-1.705h-10.137zM149.382 152.632h10.136v-1.705h-10.136zM135.022 158.6h10.137v-1.705h-10.137zM149.382 158.6h10.136v-1.705h-10.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M169.654 191h33.788v-66.504h-33.788z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323948",
    d: "M173.033 130.464h26.185v-1.705h-26.185zM173.033 134.727h26.185v-1.705h-26.185zM173.033 138.99h26.185v-1.705h-26.185zM173.033 143.254h26.185v-1.706h-26.185zM173.033 147.517h26.185v-1.706h-26.185zM173.033 152.632h26.185v-1.705h-26.185zM173.033 156.895h26.185v-1.705h-26.185z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M85.186 189.295H39.573v-31.94c0-2.137 1.577-3.87 3.522-3.87h42.09v35.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M234.823 167.966H212.86v-31.94c0-2.137.759-3.87 1.695-3.87h20.267v35.81z",
    transform: "translate(-149.637 21.33)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M63.224 160.182h21.962v-.729H63.224zM63.224 163.593h21.962v-.73H63.224zM63.224 167.003h21.962v-.729H63.224zM63.224 170.414h21.962v-.73H63.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323948",
    d: "M41.262 160.182h21.962v-.729H41.262zM41.262 163.593h21.962v-.73H41.262zM41.262 167.003h21.962v-.729H41.262zM41.262 170.414h21.962v-.73H41.262zM135.022 77.602h10.137v-1.705h-10.137zM149.382 77.602h10.136v-1.705h-10.136zM135.022 81.865h10.137V80.16h-10.137zM149.382 81.865h10.136V80.16h-10.136zM135.022 86.98h10.137v-1.704h-10.137zM149.382 86.98h10.136v-1.704h-10.136zM135.022 92.95h10.137v-1.706h-10.137zM149.382 92.95h10.136v-1.706h-10.136zM135.022 96.36h10.137v-1.706h-10.137zM149.382 96.36h10.136v-1.706h-10.136zM135.022 162.011h10.137v-1.705h-10.137zM149.382 162.011h10.136v-1.705h-10.136zM135.022 167.98h10.137v-1.706h-10.137zM149.382 167.98h10.136v-1.706h-10.136zM135.022 171.39h10.137v-1.705h-10.137zM149.382 171.39h10.136v-1.705h-10.136zM173.033 161.158h26.185v-1.705h-26.185zM173.033 165.422h26.185v-1.706h-26.185zM173.033 169.685h26.185v-1.706h-26.185z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#c)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.454 92.935H33.81c-.77 0-1.401-.854-1.401-1.897v-1.321c0-1.044.63-1.897 1.401-1.897h5.644c.771 0 1.402.853 1.402 1.897v1.32c0 1.044-.631 1.898-1.402 1.898"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M144.995 42.197h-5.32c-.727 0-1.322-.838-1.322-1.863v-1.297c0-1.025.595-1.863 1.322-1.863h5.32c.727 0 1.321.838 1.321 1.863v1.297c0 1.025-.594 1.863-1.32 1.863"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.063 67.572a4.522 4.522 0 0 1-4.524 4.52 4.522 4.522 0 0 1-4.523-4.52 4.522 4.522 0 0 1 4.523-4.52 4.522 4.522 0 0 1 4.524 4.52M34.619 67.572a4.522 4.522 0 0 1-4.524 4.52 4.522 4.522 0 0 1-4.524-4.52 4.522 4.522 0 0 1 4.524-4.52 4.522 4.522 0 0 1 4.524 4.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.312 63.214c0 4.903-3.978 8.878-8.886 8.878-4.908 0-8.886-3.975-8.886-8.878 0-4.903 3.978-8.878 8.886-8.878 4.908 0 8.886 3.975 8.886 8.878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.58 64.1c0-4.413 3.582-7.991 8-7.991s8 3.578 8 7.991c0 4.414-3.582 7.991-8 7.991s-8-3.577-8-7.991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54 72.092H30.43v-3.626H4.54z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.25 112.01a3.005 3.005 0 0 1 2.995-3.01h121.51a2.996 2.996 0 0 1 2.995 3.01V187H43.25v-74.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    d: "M32 187h150v3.749a2.245 2.245 0 0 1-2.252 2.251H34.252A2.25 2.25 0 0 1 32 190.749V187z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M99.5 187h15v1.125c0 .621-.5 1.125-1.127 1.125h-12.746c-.622 0-1.127-.5-1.127-1.125V187z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M48.5 114.25h117v68.25h-117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.12,
    d: "M48.5 114.25h68.25L48.5 182.5z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.5 126.25)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.134,
    cy: 21.918,
    fill: "#E7EAED",
    rx: 22.134,
    ry: 21.918
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.802 13.585l-13.392 5.03 7.853 7.779z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.329 31.88l5.077-13.266 7.853 7.78z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem);
export default __webpack_public_path__ + "static/media/item.dca6c2fec85db8cad47a2766ca6250d4.svg";
export { ForwardRef as ReactComponent };